import { z } from 'zod';
import superjson from 'superjson';

export const schema = z.object({
  sessionId: z.string().min(1),
  repo: z.string().min(1),
  branch: z.string().min(1),
  message: z.string().min(1),
  files: z.array(
    z.object({
      path: z.string(),
      content: z.string(),
      action: z.enum(['create', 'update', 'delete']),
    }),
  ),
});

export type InputType = z.infer<typeof schema>;

export type OutputType = {
  success: boolean;
  commitSha?: string;
  commitUrl?: string;
  error?: string;
};

export const createGithubCommit = async (
  input: InputType,
  init?: RequestInit,
): Promise<OutputType> => {
  const result = await fetch('/_api/github/commit', {
    method: 'POST',
    credentials: 'include',
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(init?.headers ?? {}),
    },
    body: JSON.stringify(input),
  });

  if (!result.ok) {
    const errorObject = superjson.parse<{ error: string }>(await result.text());
    throw new Error(errorObject.error);
  }
  return superjson.parse<OutputType>(await result.text());
};
